module.exports = __webpack_public_path__ + "static/flags/BB-b0462eb015697e757886f4cd492ac1c9.gif";